// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "tables" + "-legacy." + "482569e1" + ".js";
};